import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { getClassList, queryforSetClass, studentRelationCreateList } from '@/api'
@Component({ name: 'JoinClassListPage', components: { HighFilter } })
export default class JoinClassListPage extends Vue {
  private dataType = 1 // 1 - 审批进度 2 - 回收箱
  private totalPage = 1;
  private currentPage = 1;
  private ideaDialogVisible = false; // 审批意见弹窗
  private reCreateDialogVisible = false; // 续报弹窗
  private reCreateStudentChoose = null; // 选中的续报学生
  private studentList = []; // 续报学生的列表
  private tableloading: any = false
  private tableData = [
  ]

  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private groupChooseList: any = []
  private joinDialogVisible = false
  private joinDialogVisible1 = false
  private joinType: any = null
  private newClassName = null
  private classList: any = []
  private classChoose: any = null
  private time: any = null
  created () {
    this.initPageData()
  }

  get className () {
    if (this.joinType * 1 === 1) {
      return this.newClassName
    } else if (this.joinType * 1 === 2) {
      const result: any = this.classList.filter((item: any) => { return item.classId === this.classChoose })
      return result.length > 0 ? result[0].className : ''
    }
  }

  get groupChooseButton () {
    console.log(this.groupChooseList, this.groupChooseList.every((item: any) => item.courseId === this.groupChooseList[0].courseId), 'this.groupChooseList.every((item: any) => item.courseId === this.groupChooseList[0].courseI')
    return this.groupChooseList.length > 0 && this.groupChooseList.every((item: any) => item.courseId === this.groupChooseList[0].courseId)
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20, isGroup: this.dataType === 2 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getClassList(param)
    this.tableloading = false
    const { allPage, currentPage, studentList } = result
    this.totalPage = allPage
    this.currentPage = currentPage
    this.tableData = studentList
    this.filterData = result.search
  }

  private onTypeChange (type: any) {
    this.dataType = type
    this.currentPage = 1
    this.tableData = []
    this.totalPage = 1
    this.initPageData()
  }

  /**
   * [description] 新签学员被点击
   */
  private onCreateStudentClick () {
    this.$router.push({ path: '/student/create', query: { action: 'create' } })
  }

  /**
   * [description] 续报按钮回调函数
   */
  private onReCreateStudentClick () {
    //
  }

  /**
   * [description] 分页更改
   */
  private onPageChange () {
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  /**
   * [description] 审批意见
   */
  private onApproveClick (item: any) {
    this.$router.push({ path: '/student/join', query: { id: item.id, courseId: item.courseId, orderId: item.sellOrderId } })
  }

  /**
   * [description] 收回审批
   */
  private onBackClick (item: any) {
    //
  }

  /**
   * [description] 删除点击
   */
  private onDeleteClick (item: any) {
    this.$confirm('确定要删除么？', { type: 'warning' }).then(() => { alert('删除成功') })
  }

  /**
   * [description] 重新编辑
   */
  private onReEditClick (item: any) {
    //
  }

  private getRowKeys (row: any) {
    return row.id
  }

  private groupChoose (data: any) {
    this.groupChooseList = data.map((item: any) => { return item })
  }

  private closedialog () {
    this.newClassName = null
    this.classChoose = null
  }

  // 批量入班
  private async onGroupAllClick () {
    this.joinDialogVisible = true
    const result: any = await queryforSetClass({ courseType: this.groupChooseList[0].courseTypeId, courseId: this.groupChooseList[0].courseId })
    this.classList = result
  }

  private async onJoinClick () {
    // 确定入班
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      this.tableloading = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let list1 = []
      const type = this.joinType * 1
      if (type === 1) {
        list1 = this.groupChooseList.map((item: any) => {
          return {
            courseId: item.courseId,
            studentId: item.id,
            sellOrderId: item.sellOrderId,
            newClassName: this.newClassName
          }
        })
      } else if (type === 2) {
        list1 = this.groupChooseList.map((item: any) => {
          return {
            courseId: item.courseId,
            studentId: item.id,
            sellOrderId: item.sellOrderId,
            classId: this.classChoose
          }
        })
      }
      const { error }: any = await studentRelationCreateList({ studentList: list1 })
      if (!error) {
        this.initPageData()
      }
      this.groupChooseList = []
      const table: any = this.$refs.myTable
      table.clearSelection()
      loading.close()
      this.tableloading = false
      this.joinDialogVisible = false
      this.joinDialogVisible1 = false
    }, 300)
  }
}
